import React from 'react'
import { Center } from '@/src/views/parts/bases/Center'
import { NotificationList } from '@/src/views/parts/commons/NotificationList'
import { NftType, NotificationType } from '../../query.generated'

export type Props = {
  nftType: Array<NftType>
  notificationType: NotificationType
}

export const Layout = (props: Props) => {
  return (
    <Center className="h-full w-full p-8">
      <Center className="relative h-full w-full">
        <Center className="absolute top-0 left-0 h-full w-full">
          <NotificationList {...props} />
        </Center>
      </Center>
    </Center>
  )
}
